import { render, staticRenderFns } from "./settingSlot.vue?vue&type=template&id=6c94f009&scoped=true&"
import script from "./settingSlot.vue?vue&type=script&lang=js&"
export * from "./settingSlot.vue?vue&type=script&lang=js&"
import style0 from "./settingSlot.vue?vue&type=style&index=0&id=6c94f009&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94f009",
  null
  
)

export default component.exports